import React from 'react';
import { RetrieveRequest } from '../../../utilities/services/RequestService';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { Alert } from '../..';
import SelectBase from './SelectBase';
import { api } from '../../../config/Services';

class RegionSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            options: []
        }
    }

    retrieveData(criteria = {}, regioninactive = {}, actionspage = 'create') {
        let paging = { limit: -1, page: 1 }
        let sort = { regionname: 'asc' };
        let url = api.url.masterdata.region.retrieve;
        criteria.active = true;
        let column = [];
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ regionname, regioncode }) => {
                    return {
                        label: regionname,
                        value: regioncode
                    };
                });

                //if options deactive
                const { regioncode, regionname } = regioninactive;
                if (regioncode) {
                    options = getOptionsDeactive(actionspage, options, regioncode, regionname);
                }

                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }

}

export default RegionSelect;